import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { getSurveyComments } from '../Services/Surveys.service';
import type { SurveyCommentsRequest } from '../Types/Surveys.types';

/**
 * One page of the free text, which never travels inside `/results`.
 *
 * Keeps the previous page on screen while the next one loads, so paging does not collapse the
 * feed to a spinner and back.
 */
export const useSurveyComments = (id: string | undefined, params: SurveyCommentsRequest) =>
  useQuery({
    queryKey: surveysQueryKeys.comments(id ?? '', params),
    queryFn: () => getSurveyComments(id ?? '', params),
    enabled: Boolean(id),
    placeholderData: keepPreviousData,
  });
